import css from 'styled-jsx/css';

const style = css`
  .report-info {
    margin: 0;
    padding-bottom: 100px;
  }
  .red-action {
    display: block;
    text-align: start;
    padding-left: 24px;
    padding-top: 8px;
    padding-bottom: 12px;
    font-size: 15px;
    cursor: pointer;
    color: red;
    font-weight: 400;
  }
  .blue-action {
    display: block;
    text-align: start;
    padding-left: 24px;
    padding-top: 8px;
    padding-bottom: 12px;
    font-size: 15px;
    cursor: pointer;
    color: #1890ff;
    font-weight: 400;
  }
`;

export default style;
